import type { MpfAppBackButtonProps } from './MpfAppBackButton.props';

export const mpfAppBackButtonDefaults: Partial<MpfAppBackButtonProps> = {
  showBackNhsApp: undefined,
  showBackNhsAppWeb: undefined,
  showBackButton: false,
  goToPage: null,
  fallbackUrl: '/start',
};
